const showSandboxedInternalBrowser = adapter => url => {
  return adapter.callAction('showSandboxedInternalBrowser', { url })
}

export default showSandboxedInternalBrowser
